:host {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  font-family: var(--cms-base-font);
}

@include price-font-sizes();

@include energy-rank-color(8);

.energy-label-element {
  display: inline-flex;
  padding-left: 3px;
  align-items: center;
  margin: 0 0 0.75rem;
}

.energy-label-element.energy-version-v2 {
  height: 3.1875rem;
}

button.energy-label-element {  
  background: none;
  border: none;
  padding: 0px; /* Disable button default-padding */
}

.energy-label-element.has-label {
  cursor: pointer;
}

.svg-eek-template {
  height: 3.1875rem;
  width: 5.625rem;
}

/* V1 */

.energy-label-element.energy-version-v1 {
  padding: 0.55rem 2.1rem 0.55rem 1rem;
  clip-path: polygon(0% 0%, calc(100% - 24px) 0%, 100% 50%, calc(100% - 24px) 100%, 0% 100%);
  color: var(--cms-semanticColors-base-strong-textOnBackground);
  /*font-size: var(--cms-price-font-size); can't use tokens here because badhouse is larger than Calibri*/
  font-size: 33px;
  line-height: var(--cms-price-line-height);
  text-decoration: none;
}


.datasheet-link {
  display: flex;
  align-items: center;
  color: var(--cms-semanticColors-base-strong-text);
  font-family: TradeGothic;
  font-size: 0.875rem; /*var(--cms-fonts-brand2-087-fontSize);*/
  line-height: 1.143rem; /*var(--cms-fonts-brand2-087-lineHeight);*/
  text-decoration: underline;
  text-decoration-thickness: 0.125rem;
  text-underline-offset: 3px;
  text-decoration-color: var(--cms-semanticColors-base-strong-border);
  margin: 0 0 0.75rem;
}

.datasheet-link-wrapper {
  margin-left: 14px;  /* adjust position according to .energy-arrow */
  display: flex;
  align-items: center;
}

.datasheet-link:active {
  text-decoration: none;
  color: var(--cms-semanticColors-base-strong-active-text);
}

.datasheet-link:hover {
  text-decoration: none;
}


:host(.lg) {
  .svg-eek-template {
    height: 3.875rem;
    width: 7rem;
  }
  .energy-label-element.energy-version-v2 {
    height: 3.875rem;
  }
  .energy-label-element.energy-version-v1 {
    padding: 0.7rem 2.6rem 0.7rem 1.2rem;
    clip-path: polygon(0% 0%, calc(100% - 30.5px) 0%, 100% 50%, calc(100% - 30.5px) 100%, 0% 100%);
    font-size: 39px;
  }
  .datasheet-link-wrapper {
    margin-left: 0.965rem;
  }
}